import React from "react";
import { cn } from "../../../common/u1/cn";
import { BuildingIcon } from "../../../../assets/ui/icons";

/* No enterprise on the account. */
const SALES_EMAIL = "info@trevex.io";

export const EnterpriseEmptyState = ({ className = "" }) => (
  <section
    className={cn(
      "rounded-[18px] border border-[var(--line)] bg-white p-8 text-center sm:p-10",
      "shadow-[0_1px_2px_rgba(20,40,60,.03)]",
      className
    )}
  >
    <span
      aria-hidden="true"
      className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--coral-soft)] text-[var(--coral)]"
    >
      <BuildingIcon size={26} />
    </span>

    <h3 className="m-0 text-[20px] font-bold text-[var(--ink)] font-sans">
      Track your buyers with TREVEX
    </h3>
    <p className="mx-auto mt-2 mb-0 max-w-[560px] text-[14px] leading-[1.6] text-[var(--ink-2)] font-sans">
      Upload your customer lists and TREVEX handles profile creation, verification and
      credibility boosting. You get real-time monitoring, instant updates and effective risk
      management for smarter decisions.
    </p>
    <p className="mx-auto mt-3 mb-0 max-w-[560px] text-[13.5px] text-[var(--muted)] font-sans">
      For more information, contact us at{" "}
      <a
        href={`mailto:${SALES_EMAIL}`}
        className="font-semibold text-[var(--coral)] underline hover:text-[var(--coral-deep)]"
      >
        {SALES_EMAIL}
      </a>
      .
    </p>
  </section>
);

export default EnterpriseEmptyState;
